import { Box, Button } from '@factorialco/deprecated-design-system'

import Modal from 'modules/core/components/Modal'
import i18n from 'modules/core/lib/i18n'

import { TrainingWizardData } from 'modules/trainings/components/Revamp/NewTrainingWizard/types'

const UnlinkWorkflowsModal = ({
  setOpen,
  onChange,
}: {
  setOpen: (value: boolean) => void
  onChange(data: Partial<TrainingWizardData>): void
}) => {
  return (
    <Modal
      title={i18n.t('trainings.edit_mode.unlink_workflows_modal.title')}
      description={i18n.t('trainings.edit_mode.unlink_workflows_modal.description')}
      onClose={() => {
        onChange({ workflowStatus: true })
        if (setOpen) setOpen(false)
      }}
      onSubmit={() => {
        if (setOpen) setOpen(false)
        onChange({ workflowStatus: false })
      }}
      illustration="document-edit"
      footer={
        <Box flexDirection="row" gap="s8">
          <Button
            onClick={() => {
              if (setOpen) setOpen(false)
              onChange({ workflowStatus: true })
            }}
            type="secondary"
          >
            {i18n.t('trainings.edit_mode.basic_information.course_validity_modal.cancel')}
          </Button>
          <Button submit>
            {i18n.t('trainings.edit_mode.basic_information.course_validity_modal.submit')}
          </Button>
        </Box>
      }
    ></Modal>
  )
}

export default UnlinkWorkflowsModal
